/**
 * WithingsBodyCompositionPage - Route-Komponente für Body Composition Tab
 * Wrapper um BodyCompositionTab mit Router-Integration
 */

import React from "react";

import { useWithingsData } from "../../hooks/useWithingsData";
import { BodyCompositionTab } from "./BodyCompositionTab";

export const WithingsBodyCompositionPage: React.FC = () => {
  const { isLoadingMeasurements, measurements } = useWithingsData();

  return <BodyCompositionTab isLoading={isLoadingMeasurements} measurements={measurements} />;
};
